import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import './Toggle.scss';
import { openLoginPrompt } from 'actions/loginPrompt';

const Toggle = ({
  disabled,
  onChange,
  options,
  value,
  requiresLogin,
  requiresLoginMessage,
  requiresLoginUrl,
}) => {
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  function handleClick(val) {
    if (requiresLogin && !user) {
      dispatch(openLoginPrompt(requiresLoginMessage, requiresLoginUrl));
      return;
    } else {
      onChange(val);
    }
  }

  return (
    <div
      className={classNames('Toggle text-interface-medium', {
        disabled,
      })}
    >
      {options.map(option => (
        <div
          className={classNames('Toggle-option', {
            selected: option.value === value,
          })}
          key={option.value}
          onClick={() => handleClick(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

export default Toggle;
